import {CSSProperties} from "react"
import { BASE_ASSET_URL } from "../../config.ts";

export default function HouseReihenMittelhaus(props: {
  selected_menu_item: string;
  onEnterElement: (id: string) => void;
  onLeaveElement: (id: string) => void;
  onClickElement: (id: string) => void;
  element_styling_function: (id: string) => CSSProperties;
  icon_styling_function: (id: string) => CSSProperties;
  outline_styling_function: (id: string) => CSSProperties;
}) {
  const enter_element = props.onEnterElement;
  const leave_element = props.onLeaveElement;
  const click_element = props.onClickElement;
  const element_styling_function = props.element_styling_function;
  const icon_styling_function = props.icon_styling_function;
  const outline_styling_function = props.outline_styling_function; 

  return (  
    <>
  {/*BEGIN SVG*/}
    <svg  viewBox="0 0 3000 3000">
  <defs>
    <style>{`
      .rmh-cls-11 {
        clip-path: url(#clippath-17);
      }

      .rmh-cls-12 {
        clip-path: url(#clippath-19);
      }

      .rmh-cls-13 {
        clip-path: url(#clippath-11);
      }

      .rmh-cls-14 {
        clip-path: url(#clippath-16);
      }

      .rmh-cls-15 {
        clip-path: url(#clippath-18);
      }

      .rmh-cls-16 {
        clip-path: url(#clippath-10);
      }

      .rmh-cls-17 {
        clip-path: url(#clippath-15);
      }

      .rmh-cls-18 {
        clip-path: url(#clippath-14);
      }

      .rmh-cls-19 {
        clip-path: url(#clippath-12);
      }

      .rmh-cls-20 {
        clip-path: url(#clippath-20);
      }

      .rmh-cls-21 {
        mix-blend-mode: multiply;
      }

      .rmh-cls-22 {
        fill: #f2b00d;
      }

      .rmh-cls-23 {
        clip-path: url(#clippath-1);
      }

      .rmh-cls-24 {
        clip-path: url(#clippath-3);
      }

      .rmh-cls-25 {
        clip-path: url(#clippath-4);
      }

      .rmh-cls-26 {
        clip-path: url(#clippath-2);
      }

      .rmh-cls-27 {
        clip-path: url(#clippath-7);
      }

      .rmh-cls-28 {
        clip-path: url(#clippath-6);
      }

      .rmh-cls-29 {
        clip-path: url(#clippath-9);
      }

      .rmh-cls-30 {
        clip-path: url(#clippath-8);
      }

      .rmh-cls-31 {
        clip-path: url(#clippath-5);
      }

      .rmh-cls-32 {
        fill: #fff;
      }

      .rmh-cls-33 {
        fill: #26d93b;
      }

      .rmh-cls-34 {
        fill: #e6450c;
      }

      .rmh-cls-35 {
        fill: #e6450c;
      }

      .rmh-cls-36 {
        fill: #e6450c;
      }

      .rmh-cls-37 {
        fill: #f25e0d;
      }

      .rmh-cls-38 {
        clip-path: url(#clippath);
      }

      .rmh-cls-39 {
        fill: #d9e51a;
      }
    `}</style>
    <clipPath id="clippath">
      <rect className="rmh-cls-1" x="34.49" y="34.62" width="2881.32" height="2749.51"></rect>
    </clipPath>
    <clipPath id="clippath-1">
      <rect className="rmh-cls-1" x="788.68" y="235.75" width="787.76" height="467.13"></rect>
    </clipPath>
    <clipPath id="clippath-2">
      <rect className="rmh-cls-1" x="1259.51" y="282" width="541.54" height="434.55"></rect>
    </clipPath>
    <clipPath id="clippath-3">
      <rect className="rmh-cls-1" x="603.07" y="108" width="1392.63" height="749.89"></rect>
    </clipPath>
    <clipPath id="clippath-4">
      <rect className="rmh-cls-1" x="1107.7" y="830.76" width="784.59" height="1099.03"></rect>
    </clipPath>
    <clipPath id="clippath-5">
      <rect className="rmh-cls-1" x="1112.2" y="1721.76" width="775.6" height="742.08"></rect>
    </clipPath>
    <clipPath id="clippath-6">
      <rect className="rmh-cls-1" x="1378.33" y="1472.16" width="365.93" height="672.27"></rect>
    </clipPath>
    <clipPath id="clippath-7">
      <rect className="rmh-cls-1" x="1729.55" y="863.09" width="125.2" height="517.72"></rect>
    </clipPath>
    <clipPath id="clippath-8">
      <rect className="rmh-cls-1" x="1239.95" y="872.66" width="511.56" height="978.66"></rect>
    </clipPath>
    <clipPath id="clippath-9">
      <rect className="rmh-cls-1" x="1182.56" y="1206.27" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-10">
      <rect className="rmh-cls-1" x="1024.32" y="99.19" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-11">
      <rect className="rmh-cls-1" x="1136.45" y="434.96" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-12">
      <rect className="rmh-cls-1" x="1464.47" y="434.81" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-14">
      <polygon className="rmh-cls-1" points="611.39 1049.54 1598.8 1062.63 1598.8 1184.25 611.39 1171.16 611.39 1049.54"></polygon>
    </clipPath>
    <clipPath id="clippath-15">
      <rect className="rmh-cls-1" x="1750.47" y="899.66" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-16">
      <rect className="rmh-cls-1" x="1750.47" y="1206.27" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-17">
      <rect className="rmh-cls-1" x="1326.46" y="1952.91" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-18">
      <rect className="rmh-cls-1" x="1326.46" y="1952.91" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-19">
      <rect className="rmh-cls-1" x="1326.46" y="1952.91" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-20">
      <rect className="rmh-cls-1" x="1598.8" y="1530.55" width="121.62" height="586.33"></rect>
    </clipPath>
  </defs>
  
  <g className="rmh-cls-9">
    <g id="Ebene_1">
      <g id="interaktive_flaechen">
        <polygon id="fassade" className="rmh-cls-37" points="75.5 849.51 2825.1 831.51 2819.43 1515.18 98.65 2186.45 75.5 849.51" onPointerEnter={()=>{enter_element("fassade")}} onPointerLeave={()=>{leave_element("fassade")}} onClick={()=>{click_element("fassade")}} style={element_styling_function("fassade")}></polygon>
        <polygon id="dach" className="rmh-cls-8" points="81.16 835.31 2915.81 829.64 2733.92 423.82 69.35 34.62 81.16 835.31" onPointerEnter={()=>{enter_element("dach")}} onPointerLeave={()=>{leave_element("dach")}} onClick={()=>{click_element("dach")}} style={element_styling_function("dach")}></polygon>
        <polygon id="photovoltaik" className="rmh-cls-39" points="784.16 236.73 1188.09 285.39 1550.93 679.41 1546.68 686.49 1126.68 669.49 784.16 236.73" onPointerEnter={()=>{enter_element("photovoltaik")}} onPointerLeave={()=>{leave_element("photovoltaik")}} onClick={()=>{click_element("photovoltaik")}} style={element_styling_function("photovoltaik")}></polygon>
        <polygon id="solarthermie" className="rmh-cls-4" points="1270.3 296.73 1274.55 308.07 1651.56 707.28 1786.2 710.59 1791.87 703.5 1404.94 312.32 1270.3 296.73" onPointerEnter={()=>{enter_element("solarthermie")}} onPointerLeave={()=>{leave_element("solarthermie")}} onClick={()=>{click_element("solarthermie")}} style={element_styling_function("solarthermie")}></polygon>
        <polygon id="keller" className="rmh-cls-10" points="1776.28 1762.24 1749.35 1757.99 1735.89 1760.12 1736.25 1740.98 1239.95 1851.32 1240.06 1891.22 40.06 2180.35 34.49 2784.13 1875.02 2181.77 1880.09 1746.71 1776.28 1762.24" onPointerEnter={()=>{enter_element("keller")}} onPointerLeave={()=>{leave_element("keller")}} onClick={()=>{click_element("keller")}} style={element_styling_function("keller")}></polygon>
        <g id="fenster" onPointerEnter={()=>{enter_element("fenster")}} onPointerLeave={()=>{leave_element("fenster")}} onClick={()=>{click_element("fenster")}} style={element_styling_function("fenster")}>
          <g className="rmh-cls-38">
            <path className="rmh-cls-33" d="M2317.23,1285.55l-280.87,34.02,8.74,359.76,269.76-53.62,2.36-340.16ZM282.43,1547.52l-.47,577.09,600.95-141.73,1.18-511.89-601.65,76.54ZM884.08,1172.16l2.13-285.83-601.65,4.25-6.38,323.15,605.91-41.57ZM1725.97,1113.82s1.65-230.79,1.65-235.98-396.85,2.13-396.85,2.13l-2.36,259.37,397.56-25.51ZM1240.06,1855.78l532.91-123.31v-437.95l-531.73,61.65-1.18,499.61ZM2033.76,1092.56l714.8-50.79-.47-168.19-713.86,2.13-.47,216.85ZM2753.76,1523.66l-5.2-297.17-204.57,25.04,6.85,311.81,202.91-39.69Z"></path>
          </g>
        </g>
        <polygon id="lueftung" className="rmh-cls-6" points="1770.61 867.91 1842.9 866.49 1841.01 911.85 1840.06 1369.64 1776.28 1373.89 1728.09 1365.39 1729.51 1319.56 1776.28 1320.04 1770.61 867.91" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={element_styling_function("lueftung")}></polygon>
        <path id="heizung" className="rmh-cls-22" d="M1744.63,1760.12l-504.57,116.93-3.07,482.6,501.73-184.02,5.91-415.51ZM1736.6,1723.97l2.13-421.42-497.48,55.75v488.5l495.35-122.84Z" onPointerEnter={()=>{enter_element("heizung")}} onPointerLeave={()=>{leave_element("heizung")}} onClick={()=>{click_element("heizung")}} style={element_styling_function("heizung")}></path>
      </g>
      <g id="Rahmen">
        <g id="photovoltaik_rahmen" style={outline_styling_function("photovoltaik")}>
          <g className="rmh-cls-23">
            <path className="rmh-cls-3" d="M1560.51,702.88l-425.28-17.26-1.99-2.45-344.56-424.29v-23.13l412.89,49.43,1.75,1.87,373.12,399.91-15.93,15.92ZM1138.67,678.75l419.06,17.01,8.98-8.98-368.5-394.96-402.52-48.19v12.76l342.99,422.36Z"></path>
          </g>
        </g>
        <g id="solarthermie_rahmen" style={outline_styling_function("solarthermie")}>
          <g className="rmh-cls-26">
            <path className="rmh-cls-3" d="M1783.99,716.55l-139.1-7.89-1.9-1.98-383.48-398.68,2.36-25.99,144.24,18.22,1.7,1.72,393.24,397.55-17.06,17.06ZM1648.03,701.82h0l133.23,7.56,9.92-9.92-388.35-392.6-134.64-17.01-1.42,15.59,381.26,396.38Z"></path>
          </g>
        </g>
        <g id="dach_rahmen" style={outline_styling_function("dach")}>
          <g className="rmh-cls-24">
            <path className="rmh-cls-3" d="M1971.33,857.89h-2.66l-790.04-.47-7.43-26.69L603.07,108l789.85,113.91v22.26l602.78,592.09-24.37,21.62ZM1183.95,850.42l784.73.47,16.77-14.88h0S1385.92,247.11,1385.92,247.11v-19.13s-766.54-110.55-766.54-110.55l558.19,710.08,6.38,22.91Z"></path>
          </g>
        </g>
        <g id="fassade_rahmen" style={outline_styling_function("fassade")}>
          <g className="rmh-cls-25">
            <path className="rmh-cls-3" d="M1107.7,1929.79l5.27-1096.38,51.73-2.64,9.58,11.74,718.01-.95v903.73l-118.5,24.61-37.13-7.83-.1-5.58-7.9-449.4-482.67,53.73v537.43l-138.29,31.55ZM1119.94,840.06l-5.2,1080.95h0l124.25-28.35v-538.11l496.54-55.28,8.03,457.09,30.23,6.38h0s111.49-23.15,111.49-23.15v-891.02l-714.33.94-9.45-11.57-41.57,2.13h0Z"></path>
          </g>
        </g>
        <g id="keller_rahmen" style={outline_styling_function("keller")}>
          <g className="rmh-cls-31">
            <path className="rmh-cls-3" d="M1114.87,2463.83l-2.68-542.77,125.93-29.77v-52.96l511.72-116.57v33.78l29.2,8.65,108.75-22.66v449.58l-108.96,34.05-18.77-5.4-508.27,177.51-1.17,16.94-4.27,1.56-131.48,48.07ZM1119.23,1926.59l2.6,527.24,122.13-44.65,1.18-17.01,514.73-179.76,18.9,5.43,102.05-31.89v-435.83l-102.05,21.26-35.91-10.63v-30.24s-497.72,113.39-497.72,113.39v52.91l-125.9,29.76Z"></path>
          </g>
        </g>
        <g id="heizung_rahmen" style={outline_styling_function("heizung")}>
          <g className="rmh-cls-28">
            <path className="rmh-cls-3" d="M1653.21,2144.43l-29.47-1.85-.98-.37-88.99-33.22-.93-7.15-4.88-5.49.56-180.55-42.54-12.66c-13.37,2.62-30.2,4.97-36.42,1.75-4.71-2.43-7.3-7-7.36-12.78l-61.18-20.58-2.7-29.54,27.17-4.92.73,13.91,63.86,19.48c3.34-.68,7.59-1.29,10.49-.81,3.67.61,6.86,3.44,9.5,8.42l39.94,11.48c.16-4.74.33-10.54.33-14.14,0-1.52.2-2.96.58-4.3l-121.14-35.96,49.39-12.35,1.84.55,115.47,34.62c3.24-.24,7.14-.53,11.82-.88,8.57-.64,16.09-.71,22.6-.19l-114.44-31.01.34-12.31,33.28-7.07,163.97,45.29,2.11,20.91-24.5,6.93-.2,4.41,14.7,4.9,1.31,17.29-16.5,6.38-.04.81,36.57,11.35v198.14l-6.02,3.07-1.49,3.44-46.8,14.98ZM1625.22,2135.66l27.12,1.7,42.52-13.61,1.23-2.83,4.44-2.27v-188.69l-36.85-11.43.57-10.77,15.87-6.14-.57-7.46-15.31-5.1.66-14.74,23.72-6.71-1.04-10.3-157.7-43.56-26.22,5.57-.04,1.29,145.88,39.53.57,25.51-14.42-4.99-.1-2.38c-.07-1.49-.52-3.74-2.3-5.96-3.98-4.97-14.91-10.44-44.41-8.22-5.23.39-9.48.71-12.93.96l-4.16.31.15-1.44-112.88-33.85h0s-22.68,5.67-22.68,5.67l105.36,31.28-3.04,4.03c-.87,1.16-1.31,2.63-1.31,4.38,0,4.98-.31,13.96-.49,18.87l-.17,4.47-51.55-14.82-.68-1.43c-1.93-4.09-3.87-5.76-5.05-5.95-1.55-.25-4.91.1-8.76.94l-.89.19-70.28-21.44-.57-10.87-13.04,2.36,1.7,18.61,62.1,20.89-.36,2.84c-.37,2.91-.07,6.76,3.46,8.58,2.74,1.42,13.92,1.17,32.7-2.57l.85-.17,49.22,14.64-.57,183.12,4.54,5.1.66,5.1,85.04,31.75ZM1642.26,1875.53l.59.21-.23-10.22-9.75-2.64c2.35,1.44,4.3,3.13,5.85,5.07,2.12,2.65,3.1,5.34,3.54,7.59ZM1744.26,1662.62l-37.65-9.63-9.62,4.93-112.3-26.68v-156.14l19.84-2.94,108.25,18.67v3.29l12.57,1.64,1.68,1.68c3.19,3.19,5.27,8.68,2.73,13.75-2.84,5.67-9.63,7.05-11.65,7.34l-.75.11-2.92-.21v109.51l26.84,6.25,2.99,28.43ZM1705.77,1645.55l30.47,7.8-1.42-13.46-27.4-6.38v-122.6l9.69.71h0c1.83-.26,5.25-1.31,6.37-3.54,1.4-2.8-1.39-5.64-1.42-5.67h0l-16.3-2.13v-3.54s-101.34-17.48-101.34-17.48l-12.75,1.89v144.57l104.41,24.8,2.15-1.1,7.53-3.86Z"></path>
          </g>
        </g>
        <g id="lueftung_rahmen" style={outline_styling_function("lueftung")}>
          <g className="rmh-cls-27">
            <path className="rmh-cls-3" d="M1783.88,1380.82l-10.72-1.34-2.09-5.57-40.86-4.21-.66-50.4,39.36,4.86-.51-4.76,70.77-7.91h15.57l-.6,60.94-70.27,8.39ZM1778.23,1373.06l5.67.71,63.31-7.56.47-47.72h-8.5l-63.07,7.09.71,6.61-40.15-4.96.47,36.14,38.98,4.02,2.12,5.67ZM1770.62,923.6l.37-59.93,82.64-.57-.74,59.82-82.28.68ZM1777.95,870.62h0s-.28,45.92-.28,45.92l68.31-.57.57-45.83-68.6.47Z"></path>
          </g>
        </g>
        <g id="fenster_rahmen" style={outline_styling_function("fenster")}>
          <g className="rmh-cls-30">
            <path className="rmh-cls-3" d="M1239.95,1851.32l1.46-495.47,505.72-58.78,4.39,438.63-511.56,115.62ZM1248.39,1362.08l-1.42,480.47h0l497.48-112.44-4.25-425.2-491.81,57.17h0ZM1327.83,1151.23l.75-275.56,164.24-2.58-.75,268.85-164.24,9.3ZM1335.56,882.56l-.71,261.26,150.24-8.5.71-255.12-150.24,2.36h0ZM1597.14,1135.7v-261.73l144.41-1.31-.75,253.62-143.67,9.42ZM1604.14,880.9v247.32s129.69-8.5,129.69-8.5l.71-240h0l-130.39,1.18Z"></path>
          </g>
        </g>
      </g>
      <g id="Icons">
        <g id="fassade-2" data-name="fassade" onPointerEnter={()=>{enter_element("fassade")}} onPointerLeave={()=>{leave_element("fassade")}} onClick={()=>{click_element("fassade")}} style={icon_styling_function("fassade")}>
          <g>
            <g className="rmh-cls-29">
              <path className="rmh-cls-5" d="M1243.35,1327.89c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
            </g>
            <path className="rmh-cls-32" d="M1266.28,1262.81v-22.89h-45.84v22.89h-19.53v29.33h84.88v-29.33h-19.53.02ZM1227.18,1246.68h32.32v15.81h-32.32v-15.81ZM1207.67,1285.38v-15.81h32.28v15.81h-32.28ZM1279.03,1285.38h-32.28v-15.81h32.28v15.81Z"></path>
          </g>
        </g>
        <g id="dach-2" data-name="dach" onPointerEnter={()=>{enter_element("dach")}} onPointerLeave={()=>{leave_element("dach")}} onClick={()=>{click_element("dach")}} style={icon_styling_function("dach")}>
          <g className="rmh-cls-16">
            <path className="rmh-cls-5" d="M1085.15,220.81c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
          </g>
          <path className="rmh-cls-32" d="M1131.39,178.96l-16.6-41.02h-57.21l.07.18-15.45,37.08,6.24,2.59,12.82-30.75,12.93,31.92h57.21-.01ZM1110.24,144.69l11.13,27.5h-42.64l-11.13-27.5h42.64Z"></path>
        </g>
        <g id="photovoltaik-2" data-name="photovoltaik" onPointerEnter={()=>{enter_element("photovoltaik")}} onPointerLeave={()=>{leave_element("photovoltaik")}} onClick={()=>{click_element("photovoltaik")}} style={icon_styling_function("photovoltaik")}>
          <g id="icon">
            <g className="rmh-cls-13">
              <path className="rmh-cls-5" d="M1197.27,556.58c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
            </g>
            <polygon className="rmh-cls-32" points="1198.13 469.32 1213.87 469.32 1199.18 492.43 1219.5 492.43 1183.87 529.24 1196.19 503.6 1182.56 503.6 1198.13 469.32"></polygon>
          </g>
        </g>
        <g id="solarthermie-2" data-name="solarthermie" onPointerEnter={()=>{enter_element("solarthermie")}} onPointerLeave={()=>{leave_element("solarthermie")}} onClick={()=>{click_element("solarthermie")}} style={icon_styling_function("solarthermie")}>
          <g className="rmh-cls-19">
            <g>
              <path className="rmh-cls-5" d="M1525.29,556.42c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              <path className="rmh-cls-32" d="M1513.39,484.83c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.74,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.02Z"></path>
              <path className="rmh-cls-32" d="M1513.39,504.82c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.76,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.04Z"></path>
              <path className="rmh-cls-32" d="M1513.39,524.82c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.76,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.04Z"></path>
            </g>
          </g>
        </g>
        <g id="fenster-2" data-name="fenster" onPointerEnter={()=>{enter_element("fenster")}} onPointerLeave={()=>{leave_element("fenster")}} onClick={()=>{click_element("fenster")}} style={icon_styling_function("fenster")}>
          <g className="rmh-cls-18">
            <path className="rmh-cls-35" d="M1537.98,1184.24c33.59,0,60.8-27.23,60.8-60.82s-27.23-60.82-60.8-60.82-60.8,27.23-60.8,60.82,27.23,60.82,60.8,60.82"></path>
          </g>
          <path className="rmh-cls-32" d="M1557.01,1150.27h-38.07v-26.38h6.89v12.21h6.76v-18.97h-13.65v-20.52h38.07v53.66h0ZM1512.18,1157.03h51.58v-67.17h-51.58v67.17Z"></path>
        </g>
        <g id="lueftung-2" data-name="lueftung" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={icon_styling_function("lueftung")}>
          <g className="rmh-cls-17">
            <g>
              <path className="rmh-cls-36" d="M1811.29,1021.27c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              <path className="rmh-cls-32" d="M1825.1,939.37c.54-7.66-5.14-17.41-12.68-21.78v31.47c0,6.69,1.69,11.13,3.78,9.91,3.76-2.18,8.9-10.25,8.9-19.6"></path>
              <path className="rmh-cls-32" d="M1799.73,982.96c-.54,7.66,5.14,17.41,12.68,21.78v-31.47c0-6.69-1.69-11.13-3.78-9.91-3.76,2.18-8.9,10.25-8.9,19.6"></path>
              <path className="rmh-cls-32" d="M1790.63,948.47c-7.66-.54-17.41,5.14-21.78,12.68h31.47c6.69,0,11.13-1.69,9.91-3.78-2.18-3.76-10.25-8.9-19.6-8.9"></path>
              <path className="rmh-cls-32" d="M1834.22,973.83c7.66.54,17.41-5.14,21.78-12.68h-31.47c-6.69,0-11.13,1.69-9.91,3.78,2.18,3.76,10.25,8.9,19.6,8.9"></path>
            </g>
          </g>
          <g id="lueftung-2" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={icon_styling_function("lueftung")}>
            <g className="rmh-cls-14">
              <g>
                <path className="rmh-cls-36" d="M1811.29,1327.88c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
                <path className="rmh-cls-32" d="M1825.1,1245.98c.54-7.66-5.14-17.41-12.68-21.78v31.47c0,6.69,1.69,11.13,3.78,9.91,3.76-2.18,8.9-10.25,8.9-19.6"></path>
                <path className="rmh-cls-32" d="M1799.73,1289.57c-.54,7.66,5.14,17.41,12.68,21.78v-31.47c0-6.69-1.69-11.13-3.78-9.91-3.76,2.18-8.9,10.25-8.9,19.6"></path>
                <path className="rmh-cls-32" d="M1790.63,1255.08c-7.66-.54-17.41,5.14-21.78,12.68h31.47c6.69,0,11.13-1.69,9.91-3.78-2.18-3.76-10.25-8.9-19.6-8.9"></path>
                <path className="rmh-cls-32" d="M1834.22,1280.44c7.66.54,17.41-5.14,21.78-12.68h-31.47c-6.69,0-11.13,1.69-9.91,3.78,2.18,3.76,10.25,8.9,19.6,8.9"></path>
              </g>
            </g>
          </g>
        </g>
        <g id="keller-2" data-name="keller" onPointerEnter={()=>{enter_element("keller")}} onPointerLeave={()=>{leave_element("keller")}} onClick={()=>{click_element("keller")}} style={icon_styling_function("keller")}>
          <g className="rmh-cls-11">
            <g>
              <g className="rmh-cls-15">
                <path className="rmh-cls-5" d="M1387.26,2074.53c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              </g>
              <path className="rmh-cls-32" d="M1418.48,2023.67h-62.44v-33.77l30.12-13.76,32.3,13.7v33.83h.02,0ZM1362.79,2016.91h48.93v-22.59l-25.45-10.79-23.47,10.72v22.66h-.01Z"></path>
              <rect className="rmh-cls-32" x="1356.03" y="2023.31" width="6.76" height="24.51"></rect>
              <rect className="rmh-cls-32" x="1411.72" y="2023.31" width="6.76" height="24.51"></rect>
              <rect className="rmh-cls-32" x="1356.4" y="2030.22" width="58.7" height="6.76"></rect>
              <g className="rmh-cls-12">
                <g className="rmh-cls-21">
                  <g>
                    <path className="rmh-cls-7" d="M1400.32,1968.88"></path>
                    <path className="rmh-cls-2" d="M1400.32,1968.88"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="heizung-2" data-name="heizung" onPointerEnter={()=>{enter_element("heizung")}} onPointerLeave={()=>{leave_element("heizung")}} onClick={()=>{click_element("heizung")}} style={icon_styling_function("heizung")}>
          <g className="rmh-cls-20">
            <g>
              <path className="rmh-cls-34" d="M1659.6,2116.89c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              <path className="rmh-cls-32" d="M1629.82,2039.08c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1629.82,2083.71c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="rmh-cls-32" d="M1652.63,2039.08c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1652.63,2083.71c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="rmh-cls-32" d="M1675.45,2039.08c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1675.45,2083.71c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="rmh-cls-32" d="M1695.77,2039.08c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1695.77,2053.36c-5.81,0-10.52-4.71-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.71,10.52,10.52-4.71,10.52-10.52,10.52"></path>
              <path className="rmh-cls-34" d="M1659.6,1652.17c33.59,0,60.82-27.23,60.82-60.8s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.8,60.82,60.8"></path>
              <path className="rmh-cls-32" d="M1629.82,1574.36c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1629.82,1618.99c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="rmh-cls-32" d="M1652.63,1574.36c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1652.63,1618.99c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="rmh-cls-32" d="M1675.45,1574.36c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1675.45,1618.99c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="rmh-cls-32" d="M1695.77,1574.36c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1695.77,1588.65c-5.81,0-10.52-4.73-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.73,10.52,10.52-4.71,10.52-10.52,10.52"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
    {/*END SVG*/}
    <div className={"house-img reihenmittelhaus-img"} style={{
              backgroundImage: 'url("'+BASE_ASSET_URL+'/reihenmittelhaus.jpg")',
        }}></div>
  </>);
}
